module.exports = __webpack_public_path__ + "img/chen.480717c0.png";